import { sgT } from "./translate";

export const taxStartGuideContent = {
  texts: {
    get subtitle() { return sgT("tax.subtitle"); },
    get goal() { return sgT("tax.goal"); },
    get allDone() { return sgT("tax.allDone"); },
    get showPreviousTasks() { return sgT("showPreviousTasks"); },
    tasksLeft: ({ tasksLeft, minutesLeft }) =>
      sgT("tasksLeft", { tasksLeft, minutesLeft }),
    get footerLinks() {
      return [
        { label: sgT("openHelpCenter"), to: "/help" },
        { label: sgT("tax.goToTransactions"), to: "/transactions" },
      ];
    },
    get nextActions() {
      return [
        {
          title: sgT("tax.nextActions.vatReturns.title"),
          description: sgT("tax.nextActions.vatReturns.description"),
          label: sgT("tax.nextActions.vatReturns.label"),
          to: "/vat-returns",
          variant: "primary",
        },
        {
          title: sgT("tax.nextActions.salesTax.title"),
          description: sgT("tax.nextActions.salesTax.description"),
          label: sgT("tax.nextActions.salesTax.label"),
          to: "/settings",
        },
        {
          title: sgT("tax.nextActions.store.title"),
          description: sgT("tax.nextActions.store.description"),
          label: sgT("tax.nextActions.store.label"),
          to: "/stores",
        },
      ];
    },
  },
  defaultSteps: [
    { id: "1", step: "1", get name() { return sgT("tax.steps.profile.name"); }, category: "required" },
    { id: "3", step: "3", get name() { return sgT("tax.steps.settings.name"); }, category: "required" },
    { id: "4", step: "4", get name() { return sgT("tax.steps.transactions.name"); }, category: "required" },
    { id: "2", step: "2", get name() { return sgT("tax.steps.store.name"); }, category: "optional", optional: true },
  ],
  steps: {
    1: {
      get name() { return sgT("tax.steps.profile.name"); },
      category: "required",
      get description() { return sgT("tax.steps.profile.description"); },
      to: "/personal-settings",
      get actionLabel() { return sgT("fill"); },
      get actions() {
        return [{ label: sgT("fill"), to: "/personal-settings", variant: "primary" }];
      },
    },
    2: {
      get name() { return sgT("tax.steps.store.name"); },
      category: "optional",
      get description() { return sgT("tax.steps.store.description"); },
      to: "/stores/add",
      get actionLabel() { return sgT("fill"); },
      get actions() {
        return [{ label: sgT("fill"), to: "/stores/add", variant: "primary" }];
      },
    },
    3: {
      get name() { return sgT("tax.steps.settings.name"); },
      category: "required",
      get description() { return sgT("tax.steps.settings.description"); },
      to: "/settings",
      get actionLabel() { return sgT("fill"); },
      get actions() {
        return [{ label: sgT("fill"), to: "/settings", variant: "primary" }];
      },
    },
    4: {
      get name() { return sgT("tax.steps.transactions.name"); },
      category: "required",
      get description() { return sgT("tax.steps.transactions.description"); },
      get bullets() {
        return [
          sgT("tax.steps.transactions.bullets.marketplace"),
          sgT("tax.steps.transactions.bullets.excel"),
          sgT("tax.steps.transactions.bullets.api"),
          sgT("tax.steps.transactions.bullets.plugins"),
        ];
      },
      to: "/transactions/import",
      get actionLabel() { return sgT("fill"); },
      get actions() {
        return [
          {
            label: sgT("fill"),
            to: "/transactions/import",
            variant: "primary",
          },
        ];
      },
    },
  },
};
